


import { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { clearYellowPagesData, getYellowPagesData } from "../../features/yellowPages/yellowPagesSlice"
import styled from "styled-components"
import YellowPagesMapSide from "../../components/yellowPages/YellowPagesMapSide"
import YellowPagesIsletmeSide from "../../components/yellowPages/YellowPagesIsletmeSide"
import { useSelector } from "react-redux"


const Container = styled.div`
  display: flex;
  justify-content: space-between;
  color: ${({theme}) => theme.mainTextColor};
  width: 100% !important;

  @media (max-width: 1100px) {
    flex-direction: column-reverse;
  }


`

const menuList = [
  {
    id: 1,
    text: "Güvenli Park Yerleri",
    keyWord:"truck_stop" 
  },
  {
    id: 2,
    text: "Lokantalar",
    keyWord:"restaurant" 
  },
  {
    id: 3,
    text: "Tamirciler",
    keyWord:"car_repair" 
  },
  {
    id: 4,
    text: "Hastaneler",
    keyWord:"hospital" 
  },
]

const YellowPage = () => {

  const {isletmeList, isLoadingGetYellowPagesData, yellowPageLocation} = useSelector(state => state.yellowPages)

  const [activePoint, setActivePoint] = useState(null)

  const [activeMenu, setActiveMenu] = useState(menuList[0])

  const dispatch = useDispatch()

  useEffect(() => {

    if(yellowPageLocation){
      dispatch(getYellowPagesData({keyWord: activeMenu.keyWord, location: yellowPageLocation.location}))
    }

    return () => {
      dispatch(clearYellowPagesData())
    }
  },[yellowPageLocation, activeMenu])

  return (
    <Container>
      <YellowPagesIsletmeSide setActiveMenu={setActiveMenu} activeMenu={activeMenu} menuList={menuList} setActivePoint={setActivePoint}/>
      <YellowPagesMapSide activePoint={activePoint} isletmeList={isletmeList} menuList={menuList} activeMenu={activeMenu} setActiveMenu={setActiveMenu}/>
    </Container>
  )
}

export default YellowPage